const desc = `<p class="c0" dir="rtl">
  <span class="c2">על קברה של "אכרה" אחת  </span><span class="c3 bold">דבר</span
  ><span class="c2 c4">  1934 05 27</span>
</p>`;

export default desc;
